import { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { AdminAction } from "../../components/admin";

export default function EditCommentDialog({
  open,
  comment,
  onClose,
  onSave,
  loading = false,
}) {
  const [content, setContent] = useState("");

  useEffect(() => {
    if (open) {
      setContent(comment?.content || "");
    }
  }, [open, comment]);

  if (!comment) return null;

  const trimmed = content.trim();
  const canSave = trimmed.length > 0 && trimmed !== String(comment.content || "").trim();

  const handleSave = () => {
    if (!canSave || loading) return;
    onSave(trimmed);
  };

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { borderRadius: "12px" } }}
      aria-labelledby="edit-comment-title"
    >
      <DialogTitle
        id="edit-comment-title"
        sx={{
          fontWeight: 700,
          pb: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        Edit Comment
        <IconButton
          size="small"
          onClick={onClose}
          disabled={loading}
          aria-label="Close dialog"
          sx={{ color: "#78716c" }}
        >
          <Close fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <TextField
          autoFocus
          fullWidth
          multiline
          minRows={4}
          label="Comment"
          value={content}
          onChange={(e) => setContent(e.target.value)}
          disabled={loading}
        />
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2, gap: 1 }}>
        <AdminAction variant="outline" onClick={onClose} disabled={loading}>
          Cancel
        </AdminAction>
        <AdminAction
          variant="primary"
          onClick={handleSave}
          loading={loading}
          disabled={!canSave}
        >
          Save
        </AdminAction>
      </DialogActions>
    </Dialog>
  );
}
